module.exports = __webpack_public_path__ + "img/saddle-cloths-10.1ba3b3ee.svg";